<template>
  <div>
    <v-container grid-list-xl fluid class="px-6 py-4">
      <div class="mb-3">
        <h1 class="fs-18 lh-18 text-uppercase mt-1 font-weight-700">
          HOSPITAL
        </h1>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <v-card class="elevation-card rounded-12">
        <v-card-title class="primary white--text">
          <v-row no-gutters align="center">
            <v-col sm="6">
              Hospital List
            </v-col>
            <v-spacer />
            <v-col sm="3">
              <v-text-field
                class="pt-0 mt-0"
                id="search"
                v-model="search"
                append-icon="search"
                placeholder="Search"
                single-line
                hide-details
                dark
                @keyup="searchBrand()"
                solo-inverted
                flat
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="auto" class="pl-1">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn dark icon @click="syncData" v-on="on">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </template>
                <span>
                  Sync
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="auto" class="pl-1">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn dark icon @click="copyData" v-on="on">
                    <v-icon>file_copy</v-icon>
                  </v-btn>
                </template>
                <span>
                  Copy
                </span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-flex
            xs12
            class="text-right"
            v-if="hasPermission('create_master_data', 'create')"
          >
            <!--            <v-btn-->
            <!--              id="add-brand"-->
            <!--              depressed-->
            <!--              color="secondblue"-->
            <!--              class="white&#45;&#45;text"-->
            <!--              :to="{ name: 'brandCreate' }"-->
            <!--            >-->
            <!--              <v-icon left dark>add</v-icon>-->
            <!--              Add new brand-->
            <!--            </v-btn>-->
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :must-sort="true"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <template v-slot:item.action="{ item }">
            <v-btn
              icon
              :id="'btn-detail' + item.id"
              @click="detail(item.id)"
              v-if="hasPermission('view_master_data', 'view')"
            >
              <v-icon color="green">remove_red_eye</v-icon>
            </v-btn>
            <v-btn
              icon
              :id="'btn-edit' + item.id"
              @click="toEdit(item.id)"
              v-if="hasPermission('update_master_data', 'update')"
            >
              <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
            </v-btn>
            <v-btn
              :id="'btn-edit' + item.id"
              @click="deleteItem(item.id)"
              icon
              v-if="hasPermission('delete_master_data', 'delete')"
            >
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <label>No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../../mixins/ACLMixin';
import paginationMixin from '../../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      progressDialogLoading: true,
      loading: true,
      items: [],
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        sortBy: ['updated_at'],
        itemsPerPage: 10
      },
      search: '',
      isSearch: false,
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Hospital List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      // itemsPerPage: 10,
      headers: [
        { text: 'Name', value: 'h_name' },
        { text: 'Address', value: 'h_address' },
        { text: 'City', value: 'h_city' },
        { text: 'Province', value: 'h_province' },
        { text: 'Updated At', value: 'updated_at' }
        // {
        //   text: 'Action',
        //   value: 'action',
        //   align: 'center',
        //   sortable: false
        // }
      ],
      timeout: null
    };
  },
  watch: {
    // 'options.page'(value) {
    //   console.log(value);
    //   this.getData();
    // },
    descending(value) {
      console.log(value);
      this.getData();
    },
    'options.itemsPerPage'(value) {
      console.log(value);
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    searchBrand() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      let { page, itemsPerPage, sortBy } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      const search = {
        h_name: this.search
      };
      return this.$store
        .dispatch('sshcf/getHospitals', {
          page,
          sort,
          limit: itemsPerPage,
          search,
          orderBy: sortBy ? sortBy[0] : 'updated_at'
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = data.data.total_data;
            // this.options = data.data.pagination;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    toEdit(value) {
      this.$router.push({
        params: { id: value },
        name: 'brandEdit'
      });
    },
    detail(value) {
      this.$router.push({
        name: 'brandDetail',
        params: { id: value }
      });
    },
    deleteItem(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this brand!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        this.progressDialogLoading = true;
        this.loading = true;
        if (result.value) {
          this.$store.dispatch('regions/delete', id).then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Deleted!', data.message.text_en, 'success');
            this.getData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Cancelled', 'Your brand data has been undeleted', 'error');
        }
      });
    },
    async syncData() {
      this.loading = true;
      await this.$store.dispatch('sshcf/syncData', 'hospital');
      this.getData();
    },
    async copyData() {
      this.loading = true;
      await this.$store.dispatch('sshcf/copyData', 'hospitals');
      this.getData();
    }
  }
};
</script>
